export default "__VITE_ASSET__8b365313__"